import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static targets = ['tableView', 'graphView', 'tableButton', 'graphButton']

  connect() {
    this.showTable() // Start with table view
  }

  showTable() {
    this.tableViewTarget.classList.remove('hidden')
    this.graphViewTarget.classList.add('hidden')
    this.tableButtonTarget.classList.add('bg-white', 'text-blue-800')
    this.tableButtonTarget.classList.remove('bg-transparent')
    this.graphButtonTarget.classList.remove('bg-white', 'text-blue-800')
    this.graphButtonTarget.classList.add('bg-transparent')
  }

  showGraph() {
    this.tableViewTarget.classList.add('hidden')
    this.graphViewTarget.classList.remove('hidden')
    this.graphButtonTarget.classList.add('bg-white', 'text-blue-800')
    this.graphButtonTarget.classList.remove('bg-transparent')
    this.tableButtonTarget.classList.remove('bg-white', 'text-blue-800')
    this.tableButtonTarget.classList.add('bg-transparent')
  }
}
